import * as actions from './actions'
import { firebaseSignin, firebaseSignout } from '../signin/actions'
import { put, select, takeEvery, call } from 'redux-saga/effects'
import * as openpgp from 'openpgp/dist/openpgp'
import firebase from 'firebase'

function getKeyPair(userId) {
  return firebase
    .database()
    .ref('users/' + userId)
    .once('value')
    .then(snapshot => {
      const val = snapshot.val()
      const { private: privKey, public: pubKey } = val ? val.keys : {}
      return { privKey, pubKey }
    })
}

function* onFirebaseSignin({ payload: user }) {
  const keys = yield select(state => state.crypto.keys)
  if (!keys || !keys.public || !keys.private) {
    const { privKey, pubKey } = yield getKeyPair(user.uid)
    yield put(actions.storeKeys({ privKey, pubKey }))
    const keyPassword = localStorage.getItem('keyPassword')
    if (keyPassword) {
      yield* unlockPrivateKey({
        payload: { keyPassword, storeKeyPassword: true }
      })
    }
  }
}

function onFirebaseSignout() {
  localStorage.removeItem('keyPassword')
}

function isKeyPasswordOk(privKey, keyPassword) {
  return new Promise(resolve => {
    setTimeout(() => {
      const key = openpgp.key.readArmored(privKey).keys[0]
      const ok = key.decrypt(keyPassword)
      resolve(ok)
    })
  })
}

function* unlockPrivateKey({ payload: { keyPassword, storeKeyPassword } }) {
  try {
    const privKey = yield select(state => state.crypto.keys.private)
    yield put(actions.unlockPrivateKeyStart(keyPassword))
    const isOk = yield call(isKeyPasswordOk, privKey, keyPassword)
    if (isOk) {
      if (storeKeyPassword) {
        localStorage.setItem('keyPassword', keyPassword)
      }
      yield put(actions.unlockPrivateKeySuccess(keyPassword))
    } else {
      yield put(actions.unlockPrivateKeyWrongPassword())
    }
  } catch (err) {
    console.error(err)
    yield put(actions.unlockPrivateKeyError(err))
  }
}

export default function*() {
  yield takeEvery(firebaseSignin, onFirebaseSignin)
  yield takeEvery(firebaseSignout, onFirebaseSignout)
  yield takeEvery(actions.unlockPrivateKey, unlockPrivateKey)
}



// WEBPACK FOOTER //
// ./src/services/crypto/sagas.js